require('./bootstrap');
require('./impaddo');

window.Vue = require('vue')
window.axios = require('axios')

import store from './store'
import ScrollMagic from 'scrollmagic'
//import { TweenMax } from 'gsap'
import { mapGetters, mapMutations, mapActions } from 'vuex'


 Vue.prototype.trans = (key) => {
    return _.get(window.trans, key, key);
}

const app = new Vue({
	el: '#app',
	store,
	data() {
        return {
        	name: '',
        	email: '',
            answer: '',
            lang: Laravel.language,
            errorName: false,
            errorMail: false,
            errorMessage: false,
            errorAnswer: false,
            contact_gender: 'Mr.',
            contact_username: '',
            contact_name: '',
            contact_email: '',
            contact_phone: '',
            contact_message: '',
            contactFormMessage: '',
            activeTechnology: null,
            showQuestion: false,
            showThankYou: false,
        	primaryTechnologies: true,
            technologies: [],
            devTechnologies: [],
            otherTechnologies:[],
        	widths: [
	        	'14%',
	        	'19%',
	        	'24%',
	        	'24%',
	        	'14%'
        	],
        };
    },
    mounted() {
    	let self = this

        self.getDeveloperTechnologies().then((response) => {
            self.technologies = response.data.technologies
            self.devTechnologies = response.data.technologies

            let sw = []
            for(let i = 0; i < (self.devTechnologies.length / 5); i++) {
                let arr = self.shuffle()
                for(let j = 0; j < arr.length; j++) {
                    sw.push(arr[j])
                }
            }

            self.setShuffledWidths(sw)
        }).catch(function (rsp) {
            console.log('error')
        })

        self.getOtherTechnologies().then((response) => {
            self.otherTechnologies = response.data.technologies
        }).catch(function (rsp) {
            console.log('error')
        })

	},
    watch: {
    },
	computed: {
		...mapGetters([
            'getLoggedUser',
            'getCounter',
            'getEmptyFields',
            'getEmptyTechnologies',
            'getResponseMessage',
            'getResponseFailure',
            'getShuffledWidths',
            'getAddedTechnologies'
        ])
	},
  	components: {
  	},
	methods: {
		...mapMutations([
            'setLoggedUser',
            'setCounter',
            'setEmptyFields',
            'setEmptyTechnologies',
            'setResponseMessage',
            'setResponseFailure',
            'setShuffledWidths',
            'setAddedTechnologies'
        ]),
        ...mapActions([
            'getDeveloperTechnologies',
            'getOtherTechnologies'
        ]),
        submitContactForm() {
            let self = this
            self.errorName      = false
            self.errorMail      = false
            self.errorMessage   = false
            self.showThankYou   = false

            if(self.contact_name == '') {
                self.errorName = true
                return
            }

            if(self.contact_email == '' || !self.validEmail(self.contact_email)) {
                self.errorMail = true
                return
            }

            if(self.contact_message == '') {
                self.errorMessage = true
                return
            }

            let data = {
                'gender'    : self.contact_gender,
                'name'      : self.contact_name,
                'email'     : self.contact_email,
                'phone'     : self.contact_phone,
                'message'   : self.contact_message,
                'username'  : self.contact_username
            }

            if(self.contact_username == '') {
                axios.post(Laravel.baseURL + '/mail',{
                        'data': data
                    }).then(function (response) {
                        self.contact_gender     = 'Mr.'
                        self.contact_name       = ''
                        self.contact_email      = ''
                        self.contact_phone      = ''
                        self.contact_message    = ''
                        self.errorName          = false
                        self.errorMail          = false
                        self.errorMessage       = false
                        self.showThankYou       = true

                        gtag('event', 'click', {
                            'event_category': 'Contact Form Submission',
                            'event_label': self.contact_email
                        })

                    }).catch(function (error) {
                        self.showThankYou       = false
                        self.contactFormMessage = error.response.data.message
                });
            }
        },
        submitForm() {
        	let self = this
        	self.setEmptyFields(false)
        	self.setEmptyTechnologies(false)
        	self.setResponseFailure(false)
        	self.setResponseMessage('')

        	if(self.name == '' || self.email == '' || !self.validEmail(self.email)) {
        		self.setEmptyFields(true)
        		return
        	}

        	if(self.getAddedTechnologies.length == 0) {
        		self.setEmptyTechnologies(true)
        		return
        	}

        	axios.post(Laravel.baseURL + '/job',{
	        		'technologies': self.getAddedTechnologies,
	        		'name': self.name,
	        		'email': self.email
        		}).then(function (response) {
                    self.name = ''
                    self.email = ''
                    self.setResponseMessage(response.data.message)
                    self.setAddedTechnologies([])

                    gtag('event', 'click', {
                        'event_category': 'Job Form Submission',
                        'event_label': self.email
                    })

                }).catch(function (error) {
                    self.setResponseFailure(true)
                    self.setResponseMessage(error.response.data.message)
            });
        },
        reloadSkillset() {
        	let self = this

        	//reset technologies
        	self.primaryTechnologies = !self.primaryTechnologies
        	self.setAddedTechnologies([])

        	if(!self.primaryTechnologies) {
                self.technologies = self.otherTechnologies
        	} else {
                self.technologies = self.devTechnologies
        	}
        	
        },
        shuffle() {
        	let array = this.widths
        	var currentIndex = array.length, temporaryValue, randomIndex
        	while (0 !== currentIndex) {

        		randomIndex = Math.floor(Math.random() * currentIndex)
        		currentIndex -= 1

        		temporaryValue = array[currentIndex]
        		array[currentIndex] = array[randomIndex]
        		array[randomIndex] = temporaryValue

        	}

        	return array
        },
        setActiveTechnology(technology) {
            let self = this

            gtag('event', 'click', {
                'event_category': 'Job Form Skill',
                'event_label': technology.technology_name
            })

            if(self.inTechnologies(technology)) {
                self.addRemoveTechnology(technology)
                return
            }

            if(self.activeTechnology && self.activeTechnology.technology_name == technology.technology_name) {
                self.activeTechnology = null
                self.showQuestion = false
                return
            }

            if(technology.form_question) {
                self.activeTechnology = technology
                self.showQuestion = true
            } else {
                self.addRemoveTechnology(technology)
            }
            
        },
        inTechnologies(technology) {
            let self = this
            for(let i = 0; i < self.getAddedTechnologies.length; i++) {
                if(self.getAddedTechnologies[i].technology.technology_name == technology.technology_name) {
                    return true;
                }
            }

            return false
        },
        saveAnswer() {
            let self = this
            if(self.answer.length > 0) {
                self.addRemoveTechnology(self.activeTechnology)
            } else {
                self.errorAnswer = true
            }
        },
        addRemoveTechnology(technology) {
        	let self = this

        	for(let i = 0; i < self.getAddedTechnologies.length; i++) {
                if(self.getAddedTechnologies[i].technology.technology_name == technology.technology_name) {
                    self.getAddedTechnologies.splice(i, 1)
                    self.answer = ''
                    elf.errorAnswer = false
                    self.showQuestion = false
                    self.activeTechnology = null
                    return;
                }
            }

            let data = {
                'technology'  : technology,
                'answer'      : self.answer
            }

            self.answer = ''
            self.errorAnswer = false
            self.showQuestion = false
            self.activeTechnology = null

            self.getAddedTechnologies.push(data)
        },
        validEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email)
        }
    },
});

// init controller
if($('#about').html() !== undefined) {
    var bodyController = new ScrollMagic.Controller();

    // create a scene
    var sceneTeam = new ScrollMagic.Scene({
        triggerElement: '#about',
        duration: 1200
    }).on('enter leave', function () {
        $('#thirdModule').toggleClass('draw-border')
        $('.third-module-wrapper').toggleClass('fade-in')
    }).addTo(bodyController)

    var sceneFirst = new ScrollMagic.Scene({
        triggerElement: '#processes',
        duration: "100%"
    }).on('enter leave', function () {
        $('#imageWrapper').toggleClass('image-wrapper-animate')
        $('.first-module-wrapper').toggleClass('fade-in')
    }).addTo(bodyController)

    var sceneSecond = new ScrollMagic.Scene({
        triggerElement: '#services',
        duration: 1200
    }).on('enter leave', function () {
        $('.second-module-wrapper').toggleClass('fade-in')
        $('#secondModule').toggleClass('text-wrapper-animate')
        $('#imageWrapperSecond').toggleClass('image-wrapper-animate')

        if($(window).height() > 600) {
            $('#imageWrapperSecond').toggleClass('draw-border')
        }

    }).addTo(bodyController)

    var sceneNews = new ScrollMagic.Scene({
        triggerElement: '#homescreen-news',
        duration: "100%"
    }).on('enter leave', function () {
        $('.homescreen-news-slider').toggleClass('fade-in')
    }).addTo(bodyController)

    /*var sceneNews = new ScrollMagic.Scene({
        triggerElement: '#news',
        duration: "100%"
    }).setTween(".news-slider", 0.5, {backgroundColor: "green", scale: 2.5}).addTo(bodyController)*/

    var sceneContact = new ScrollMagic.Scene({
        triggerElement: '#contact',
        duration: 1500
    }).on('enter leave', function () {
        $('.welcome-contact').toggleClass('fade-in')
        $('.contact-form-homescreen').toggleClass('fade-in')
    }).addTo(bodyController)


    bodyController.addScene([
      sceneTeam,
      sceneFirst,
      sceneSecond,
      sceneNews,
      sceneContact
    ])
}